export default "__VITE_ASSET__Dg3v1lZH__"